import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import ExpandableSection from "@/components/job/ExpandableSection";
import { Button } from "@/components/ui/button";
import { TextInput } from "@/components/ui/textInput";
import { inputStep, maxInputNumber } from "@/constants/inputs";
import useCUCompositeJobStore from "@/store/useCUCompositeJobStore";

const cardName = "extraLayers";

const extraLayersSchema = z.object({
  extra_layers: z.union([
    z.number().lt(maxInputNumber),
    z.string().refine((value) => !isNaN(Number.parseFloat(value)), { message: "Must be a number" }),
  ]),
});

type ExtraLayersSchema = z.infer<typeof extraLayersSchema>;
export function ExtraLayers() {
  const { sections, toggleExpandableSection, setExtraLayers } = useCUCompositeJobStore();
  const savedExtraLayers = sections.extraLayers;

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<ExtraLayersSchema>({
    resolver: zodResolver(extraLayersSchema),
    values: {
      extra_layers: savedExtraLayers?.data.extra_layers ?? "",
    },
  });

  const saveAndContinue = (formData?: ExtraLayersSchema) => {
    const extra_layers = formData
      ? typeof formData.extra_layers === "string"
        ? Number(formData.extra_layers)
        : formData.extra_layers
      : null;
    setExtraLayers({ data: { extra_layers }, status: "done" });
  };

  return (
    <ExpandableSection
      status={savedExtraLayers?.status ?? "hidden"}
      setIsExpanded={() => toggleExpandableSection(cardName)}
      title="Extra Layers"
    >
      <form onSubmit={handleSubmit(saveAndContinue)} className="mx-2 flex flex-col flex-wrap gap-6">
        <TextInput
          className="w-60 flex-1"
          label="Extra Layers"
          step={inputStep}
          {...register("extra_layers")}
          error={errors.extra_layers?.message}
        />
        <Button className="w-full self-end md:w-fit" type="submit">
          Save
        </Button>
      </form>
    </ExpandableSection>
  );
}
